import React from 'react';
import { Sparkles } from 'lucide-react';
import { TwitterIcon, GithubIcon, LinkedinIcon } from './SocialIcons';
import { Staff } from '../types';

interface StaffCardProps {
  member: Staff;
}

export const StaffCard: React.FC<StaffCardProps> = ({ member }) => {
  return (
    <div className="group bg-slate-900/60 rounded-2xl border border-slate-800/80 hover:border-purple-500/40 p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/10 hover:-translate-y-1">
      {/* Avatar Container with Gradient Border */}
      <div className="relative mb-5">
        <div className="w-24 h-24 rounded-full bg-gradient-to-tr from-cyan-500 via-indigo-500 to-fuchsia-500 p-1 shadow-lg shadow-purple-500/20 group-hover:shadow-purple-500/40 transition-all">
          <img
            src={member.avatar_url}
            alt={member.name}
            className="w-full h-full object-cover rounded-full bg-slate-950"
            loading="lazy"
          />
        </div>
        <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-slate-950 border border-slate-700 flex items-center justify-center text-cyan-400">
          <Sparkles className="w-3.5 h-3.5" />
        </div>
      </div>

      {/* Details */}
      <h3 className="text-lg font-bold text-white group-hover:text-purple-300 transition-colors">
        {member.name}
      </h3>
      <p className="text-xs font-semibold text-cyan-400 uppercase tracking-wider mt-1">
        {member.role}
      </p>

      {member.bio && (
        <p className="text-slate-400 text-xs mt-3 leading-relaxed max-w-xs">
          {member.bio}
        </p>
      )}

      {/* Social Links */}
      <div className="flex items-center gap-2.5 mt-5 pt-4 border-t border-slate-800/80 w-full justify-center">
        {member.twitter && (
          <a
            href={member.twitter}
            target="_blank"
            rel="noreferrer"
            className="w-8 h-8 rounded-lg bg-slate-800/60 hover:bg-slate-700 text-slate-400 hover:text-cyan-400 border border-slate-700/50 flex items-center justify-center transition"
            title="Twitter"
          >
            <TwitterIcon className="w-4 h-4" />
          </a>
        )}
        {member.github && (
          <a
            href={member.github}
            target="_blank"
            rel="noreferrer"
            className="w-8 h-8 rounded-lg bg-slate-800/60 hover:bg-slate-700 text-slate-400 hover:text-white border border-slate-700/50 flex items-center justify-center transition"
            title="GitHub"
          >
            <GithubIcon className="w-4 h-4" />
          </a>
        )}
        {member.linkedin && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noreferrer"
            className="w-8 h-8 rounded-lg bg-slate-800/60 hover:bg-slate-700 text-slate-400 hover:text-blue-400 border border-slate-700/50 flex items-center justify-center transition"
            title="LinkedIn"
          >
            <LinkedinIcon className="w-4 h-4" />
          </a>
        )}
      </div>
    </div>
  );
};
